export const referentielSelector = (state) => state.referentiel.version;
export const navbarFamSelector = (state) => state.referentiel.navbar_Famil;
export const navbarFamSelectedSelector = (state) => state.referentiel.navbar_Famil_selected;